import React from 'react'

export default function Button({ onHandleDarkMode, curMode }) {
    return (
        <div class="checkbox-wrapper-3">
            {curMode === "Dark" ?
                <input type="checkbox" id="cbx-3" onClick={onHandleDarkMode} checked />
                :
                <input type="checkbox" id="cbx-3" onClick={onHandleDarkMode} />}
            <label for="cbx-3" class="toggle"><span></span></label>
        </div>
    )
}
